import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { BackToTownButton } from '../components/BackToTownButton';

export const TypingUnavailable = () => (
  <main className="min-h-screen bg-[#e4d2a4] flex flex-col items-center justify-center gap-8 px-6 py-12 text-main_text">
    <Helmet><title>タイピングをえらぼう</title></Helmet>
    <h1 className="text-2xl font-bold text-center">このタイピングは終了しました</h1>
    <p className="text-center">ほかのタイピングをえらんでね。</p>
    <div className="flex flex-wrap justify-center gap-6 w-full max-w-3xl">
      {[
        { theme: 'micratch', name: 'マイクラッチ', language: '日本語（ローマ字）' },
        { theme: 'roblox', name: 'ロブロックス', language: '英語' },
      ].map(({ theme, name, language }) => (
        <Link key={theme} to={`/practice/${theme}`} className="w-64 bg-white rounded-xl p-6 flex flex-col items-center gap-5 focus-visible:outline focus-visible:outline-4 focus-visible:outline-current_key">
          <span className="font-bold">{language}</span>
          <img className="h-28 w-full object-contain" src={`/${theme}/menu/title.webp`} alt={`${name}タイピング`} />
          <span className="rounded-full bg-red-500 text-white py-2 px-8 font-bold">はじめる ▶</span>
        </Link>
      ))}
    </div>
    <BackToTownButton />
  </main>
);
